import { CASES } from './constants';
import {
    PAGINATION_STORAGE_KEYS,
    DEFAULT_PAGE_SIZE_OPTIONS,
    getStoredItemsPerPage,
    getInitialPaginationRange,
    withPreservedPagination,
    persistItemsPerPage,
} from 'datastage/utils/paginationPreferences.js';

const getInitialProductGateSort = () => {
    const saved = localStorage.getItem('productGateSort');
    return saved ? JSON.parse(saved) : ['id', 'DESC'];
};

/**
 * Gets the initial items per page from localStorage.
 * Falls back to 25 (ProductGate default) if not found.
 */
const getInitialItemsPerPage = () => {
    return getStoredItemsPerPage(PAGINATION_STORAGE_KEYS.productGate, 25);
};

// Initialize with stored preference
const initialItemsPerPage = getInitialItemsPerPage();

/**
 * Initial state for the product gate slice.
 *
 * Key state values:
 * - productUpdates: Array of product update objects for the grid
 * - filterForm: Search form field values
 * - isJobStatusOpen: Boolean to control job status drawer visibility
 * - isStaleTitlesOpen: Boolean to control stale titles drawer visibility
 * - refreshProductGate: Boolean flag to trigger grid refresh from other components
 * - itemsPerPage: User's persisted page size preference (from localStorage)
 */
const initialState = {
    productUpdates: [],
    filterForm: {
        fromDate: '',
        toDate: '',
        title: '',
        groupId: '',
        productId: '',
        hideIgnored: true,
        hideCompleted: true,
        hideUpdates: true,
        hideNA: false,
    },
    isJobStatusOpen: false,
    isStaleTitlesOpen: false,
    jobDetails: {},
    espnTitle: false,
    dataToggle: 'contentSales',
    totalPages: 0,
    totalItems: 0,
    currentPage: 0,
    filterParam: '',
    productGateRange: getInitialPaginationRange(initialItemsPerPage),
    productGateSort: getInitialProductGateSort(),
    defaultFilterRange: getInitialPaginationRange(initialItemsPerPage),
    itemsPerPage: initialItemsPerPage,
    pageSizeOptions: DEFAULT_PAGE_SIZE_OPTIONS,
    // Flag to trigger grid refresh from other components
    refreshProductGate: false,
};

export function productGate(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case CASES.UPDATE_PRODUCT_GATE: {
            // Persist sort preference to localStorage
            if (payload.productGateSort) {
                localStorage.setItem('productGateSort', JSON.stringify(payload.productGateSort));
            }
            // Persist page size preference to localStorage
            if (payload.itemsPerPage !== undefined) {
                persistItemsPerPage(PAGINATION_STORAGE_KEYS.productGate, payload.itemsPerPage);
            }
            return { ...state, ...payload };
        }
        case CASES.UPDATE_PRODUCT_GATE_FORM: {
            const { data, key } = payload;
            return { ...state, [key]: { ...state[key], ...data } };
        }
        case CASES.CLEAR_PRODUCT_GATE: {
            // Preserve pagination preferences when clearing
            return withPreservedPagination(
                state,
                {
                    ...initialState,
                    productGateSort: state.productGateSort,
                },
                ['productGateRange', 'defaultFilterRange']
            );
        }
        default:
            return state;
    }
}
